const logoutMessages = {
  'logout.message': 'ログアウトしています...',
  'logout.button.name': 'ログアウト',
};

export default logoutMessages;
